import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M13 15.5a1.5 1.5 0 0 1 3 0v4a1.5 1.5 0 0 1-3 0z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M20 12a8 8 0 1 0-9 7.938V20c0 .767.288 1.467.761 1.997C6.35 21.87 2 17.443 2 12 2 6.477 6.477 2 12 2s10 4.477 10 10q0 .374-.027.74A3 3 0 0 0 20 12"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M17 12a5 5 0 1 0-6 4.9V15a3 3 0 0 1 3-3zm1 3.5a1.5 1.5 0 0 1 3 0v4a1.5 1.5 0 0 1-3 0z"
    }
  )
);
var SvgRecordingPauseOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var RecordingPauseOutlined_default = SvgRecordingPauseOutlined;

export { RecordingPauseOutlined_default as default };
